/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from '../../../../../src/app/components/guest/guest.module';
import * as i2 from '../../../../node_modules/angular2-modal/src/angular2-modal.ng-flat.ngfactory';
import * as i3 from '../../../../node_modules/angular2-modal/plugins/bootstrap/src/angular2-modal-bootstrap.ng-flat.ngfactory';
import * as i4 from '../../shared/components/tooltip/tooltip.component.ngfactory';
import * as i5 from './guest.component.ngfactory';
import * as i6 from './components/client/candidate-profile/candidate-profile.component.ngfactory';
import * as i7 from './components/client/billing/billing.component.ngfactory';
import * as i8 from '@angular/common';
import * as i9 from '@angular/forms';
import * as i10 from 'angular2-modal';
import * as i11 from 'angular2-modal/plugins/bootstrap';
import * as i12 from '@angular/platform-browser';
import * as i13 from '../../../../../src/app/components/guest/services/auth-http.service';
import * as i14 from '@angular/http';
import * as i15 from '../../../../../src/app/components/guest/services/guest-guard.service';
import * as i16 from '../../../../../src/app/components/guest/services/base.service';
import * as i17 from '../../../../../src/app/components/guest/services/client/client.service';
import * as i18 from '../../../../../src/app/components/guest/services/export/client/export.service';
import * as i19 from '../../../../../src/app/shared/services/time.service';
import * as i20 from 'angular2-moment/moment.module';
import * as i21 from '../../../../../src/app/shared/shared.module';
import * as i22 from '@angular/router';
import * as i23 from '../../../../../src/app/components/guest/guest.component';
import * as i24 from '../../../../../src/app/components/guest/components/client/candidate-profile/candidate-profile.component';
import * as i25 from '../../../../../src/app/components/guest/components/client/billing/billing.component';
export const GuestModuleNgFactory:i0.NgModuleFactory<i1.GuestModule> = i0.ɵcmf(i1.GuestModule,
    ([] as any[]),(_l:any) => {
      return i0.ɵmod([i0.ɵmpd(512,i0.ComponentFactoryResolver,i0.ɵCodegenComponentFactoryResolver,
          [[8,[i2.ModalOverlayNgFactory,i2.CSSBackdropNgFactory,i2.CSSDialogContainerNgFactory,
              i3.BSModalContainerNgFactory,i3.BSMessageModalNgFactory,i4.TooltipComponentNgFactory,
              i5.GuestComponentNgFactory,i6.CandidateProfileComponentNgFactory,i7.BillingComponentNgFactory]],
              [3,i0.ComponentFactoryResolver],i0.NgModuleRef]),i0.ɵmpd(4608,i8.NgLocalization,
          i8.NgLocaleLocalization,[i0.LOCALE_ID]),i0.ɵmpd(4608,i9.ɵi,i9.ɵi,([] as any[])),
          i0.ɵmpd(4608,i10.OverlayRenderer,i10.DOMOverlayRenderer,[i0.ApplicationRef,
              i0.Injector]),i0.ɵmpd(4608,i10.Overlay,i10.Overlay,[i10.OverlayRenderer,
              i0.Injector]),i0.ɵmpd(4608,i10.Modal,i11.Modal,[i10.Overlay]),i0.ɵmpd(4608,
              i11.Modal,i11.Modal,[i10.Overlay]),i0.ɵmpd(4608,i9.FormBuilder,i9.FormBuilder,
              ([] as any[])),i0.ɵmpd(5120,i12.EVENT_MANAGER_PLUGINS,() => {
            return [new i10.ɵa()];
          },([] as any[])),i0.ɵmpd(4608,i13.AuthHttpService,i13.AuthHttpService,[i14.Http]),
          i0.ɵmpd(4608,i15.GuestGuardService,i15.GuestGuardService,[i13.AuthHttpService]),
          i0.ɵmpd(4608,i16.BaseService,i16.BaseService,([] as any[])),i0.ɵmpd(4608,
              i17.ClientService,i17.ClientService,[i13.AuthHttpService]),i0.ɵmpd(4608,
              i18.ExportService,i18.ExportService,[i13.AuthHttpService]),i0.ɵmpd(4608,
              i19.TimeService,i19.TimeService,([] as any[])),i0.ɵmpd(512,i8.CommonModule,
              i8.CommonModule,([] as any[])),i0.ɵmpd(512,i9.ɵba,i9.ɵba,([] as any[])),
          i0.ɵmpd(512,i9.FormsModule,i9.FormsModule,([] as any[])),i0.ɵmpd(512,i20.MomentModule,
              i20.MomentModule,([] as any[])),i0.ɵmpd(512,i10.ModalModule,i10.ModalModule,
              ([] as any[])),i0.ɵmpd(512,i11.BootstrapModalModule,i11.BootstrapModalModule,
              ([] as any[])),i0.ɵmpd(512,i9.ReactiveFormsModule,i9.ReactiveFormsModule,
              ([] as any[])),i0.ɵmpd(512,i21.SharedModule,i21.SharedModule,([] as any[])),
          i0.ɵmpd(512,i22.RouterModule,i22.RouterModule,[[2,i22.ɵa],[2,i22.Router]]),
          i0.ɵmpd(512,i1.GuestModule,i1.GuestModule,([] as any[])),i0.ɵmpd(1024,i22.ROUTES,
              () => {
                return [[{path:'',component:i23.GuestComponent,canActivate:[i15.GuestGuardService],
                    children:[{path:'candidate/profile',component:i24.CandidateProfileComponent},
                        {path:'client/billing',component:i25.BillingComponent}]}]];
              },([] as any[]))]);
    });
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUvbm9kZS9hcHAvc3JjL2FwcC9jb21wb25lbnRzL2d1ZXN0L2d1ZXN0Lm1vZHVsZS5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9ob21lL25vZGUvYXBwL3NyYy9hcHAvY29tcG9uZW50cy9ndWVzdC9ndWVzdC5tb2R1bGUudHMiXSwic291cmNlc0NvbnRlbnQiOlsiICJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7In0=



// WEBPACK FOOTER //
// ./node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./compiled/src/app/components/guest/guest.module.ngfactory.ts